import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React from "react";
import { makeStyles } from "@mui/styles";
import { jsx as _jsx } from "react/jsx-runtime";
var DrawerFormTwoColWrapper = function DrawerFormTwoColWrapper(_ref) {
  var children = _ref.children,
    _ref$secondColHidden = _ref.secondColHidden,
    secondColHidden = _ref$secondColHidden === void 0 ? true : _ref$secondColHidden;
  var useStyles = makeStyles(function (theme) {
    return {
      twoColWrapper: _defineProperty(_defineProperty({
        display: "flex",
        alignItems: secondColHidden ? "stretch" : "center",
        gap: secondColHidden ? "0px" : "16px"
      }, theme.breakpoints.down("sm"), {
        flexDirection: "column"
      }), "& > *", {
        // ensures each column takes up equal width, if they each use 'fullWidth' property
        flex: 1
      })
    };
  });
  var classes = useStyles();
  return /*#__PURE__*/_jsx("div", {
    className: classes.twoColWrapper,
    children: children
  });
};
export default DrawerFormTwoColWrapper;